module.exports = __webpack_public_path__ + "img/body-3.623d7e12.png";